<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>门店所有人</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入手机号码" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Jigouname" label="门店名称" min-width="15%"></el-table-column>
          <el-table-column prop="Name" label="姓名" min-width="5%"></el-table-column>
          <el-table-column prop="Phone" label="手机号码" min-width="10%"></el-table-column>
          <el-table-column prop="Sumbonus" label="累计已获得分润金额" min-width="12%"></el-table-column>
          <el-table-column prop="Sumjine" label="累计已成功提现金额" min-width="12%"></el-table-column>
          <el-table-column prop="Mendianbonus" label="当前剩余未提现金额" min-width="12%"></el-table-column>
          <el-table-column prop="Createtime" label="注册时间" min-width="12%"></el-table-column>
          <el-table-column label="操作" min-width="15%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goStoreOwnerChange(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goDistributionRecord(scope.row)">分润记录</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goLoanRecord(scope.row)">放款记录</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加门店所有人">
        <el-form :model="addForm" ref="addFormRef" label-width="75px">
          <el-form-item label="选择门店" class="addAdminForm">
            <Rsljigou :propsjigouid="addForm.jigouid" :propsjigouname="addForm.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="姓名" class="addAdminForm">
            <el-input v-model="addForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" class="addAdminForm">
            <el-input v-model="addForm.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <StoreOwnerChange ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></StoreOwnerChange>
      </el-tab-pane>

      <el-tab-pane label="分润记录" name="three" disabled="disabled">
        <StoreOwnerFenRun ref="SubVuethree" v-on:triggerFunc="BackToFirst"></StoreOwnerFenRun>
      </el-tab-pane>

      <el-tab-pane label="放款记录" name="four" disabled="disabled">
        <StoreOwnerFangKuan ref="SubVuefour" v-on:triggerFunc="BackToFirst"></StoreOwnerFangKuan>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import StoreOwnerChange from '@/componentsSubVue/StoreOwnerChange.vue'
import StoreOwnerFenRun from '@/componentsSubVue/StoreOwnerFenRun.vue'
import StoreOwnerFangKuan from '@/componentsSubVue/StoreOwnerFangKuan.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    StoreOwnerChange,
    StoreOwnerFenRun,
    StoreOwnerFangKuan
  },
  name: 'MyStoreOwner',
  data () {
    return {
      loading: false,
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询
      keywords: {
        phone: '',
        name: '',
        jigouid: '0',
        jigouname: ''
      },
      // 添加
      addForm: {
        jigouid: '0',
        jigouname: '',
        name: '',
        phone: ''
      }
    }
  },
  mounted () {
    this.apiStoreOwnernum()
    this.apiStoreOwnerlist()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
      this.addForm.jigouid = vid
      this.addForm.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiStoreOwnerlist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiStoreOwnernum()
      this.apiStoreOwnerlist()
    },
    clickadd () {
      this.apiAddStoreOwner()
    },
    goStoreOwnerChange (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData({ name: '', params: { id: row.Id, name: row.Name, phone: row.Phone } })
    },
    goDistributionRecord (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData({ name: '', params: { jigouid: row.Jigouid } })
    },
    goLoanRecord (row) {
      this.activeName = 'four'
      this.$refs.SubVuefour.LoadData({ name: '', params: { jigouid: row.Jigouid } })
    },
    apiStoreOwnerlist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        phone: that.keywords.phone,
        name: that.keywords.name,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_StoreOwnerlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiStoreOwnernum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        phone: that.keywords.phone,
        name: that.keywords.name,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_StoreOwnernum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddStoreOwner: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.addForm.jigouid,
        phone: that.addForm.phone,
        name: that.addForm.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddStoreOwner, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiStoreOwnernum()
            that.apiStoreOwnerlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
